/**
 * Typed access to build-time configuration.
 *
 * Everything here is inlined into the bundle and readable by anyone, so only
 * non-secret values belong in `.env.local`.
 */
interface AppEnv {
  apiBaseUrl: string;
  appName: string;
  isDevelopment: boolean;
  isProduction: boolean;
}

function required(value: string | undefined, key: string, fallback: string): string {
  if (!value || value.length === 0) {
    if (import.meta.env.DEV) {
      console.warn(`[env] ${key} is not set; falling back to "${fallback}"`);
    }
    return fallback;
  }
  return value;
}

export const env: AppEnv = {
  apiBaseUrl: required(import.meta.env.VITE_API_BASE_URL, 'VITE_API_BASE_URL', '/api/v1'),
  appName: required(import.meta.env.VITE_APP_NAME, 'VITE_APP_NAME', 'WinDocs'),
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};
